// extracted by mini-css-extract-plugin
module.exports = {"heading":"tag-module--heading--1Kl-x","cover":"tag-module--cover--2AxsX"};